import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=29c1e64e"
import script from "./ProductBox.vue?vue&type=script&lang=ts"
export * from "./ProductBox.vue?vue&type=script&lang=ts"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=29c1e64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports